// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"_3fdGC___UpdateSearchDropdown-module__dropdownMenu"};